import React from 'react';
import debounce from 'debounce';
import { Select } from 'antd';

import {
    _getSearchProducts
} from '../../services'

const { Option } = Select;

class ProductSearch extends React.PureComponent{

    render() {

        const { width, products } = this.state;

        return (
            <Select
            showSearch
            value={this.props.value}
            placeholder={this.props.placeholder}
            style={this.props.style}
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={this.handleSearch}
            onChange={this.handleChange}
            notFoundContent={null}
            disabled={this.props.disabled}
          >
            {products.map(_product => <Option value={`${_product._id}`}>{_product.title}</Option>)}
          </Select>
        )

	}

	state = {
		width: 200,
		loading: false,
		products: []
	}

	constructor(props){
		super(props);
		this.searchProducts = debounce(this.searchProducts, 500);
	}

    handleSearch = value => {

        if (value) {
            this.searchProducts(value)
        } else {
            this.setState({ products: [] });
        }
    };

    handleChange = value => {
        // get id and title
        let { products } = this.state

        let selected = products.filter(_product => `${_product._id}` == value)[0]

        this.props.onChange(`${selected._id}`, selected.title)
    };

	searchProducts = (value) => {
		_getSearchProducts({
            searchParam: value,
            limit: 10
        })
			.then( res => {
				this.setState({
					products: res.data.products,
					loading: false
				})
			})
	}

}

export default ProductSearch;


// WEBPACK FOOTER //
// ./src/components/sla-discrepancies/product-search.js